import type IExportRepository from '@/core/domain/exports/IExportRepository.ts'
import { apiService } from '@/core/infrastructure/services/apiServiceFactory.ts'
import ExportFilterSchool from '@/core/domain/exports/ExportFilterSchool.ts'
import type { ExportFilterSchoolEntity } from '@/core/infrastructure/schemas/exports/ExportSchema.ts'
import ExportFilterInput from '@/core/domain/exports/ExportFilterInput.ts'
import ExportResult from '@/core/domain/exports/ExportResult.ts'
import { ExportType } from '@/core/domain/resources/enums/ExportType.ts'
import type { AxiosRequestConfig } from 'axios'

export default class ExportRepository implements IExportRepository {
  /**
   * Fetch data filters for a school year
   * @param schoolYearId
   */
  async fetchDataFiltersBySchoolYearId(schoolYearId: number): Promise<ExportFilterSchool[]> {
    const response = await apiService.get<ExportFilterSchoolEntity[]>(
      `exports/filters/${schoolYearId}`
    )
    return response.data.map((res) => ExportFilterSchool.create(res))
  }

  /**
   * Fetch export file data
   * @param key
   * @param filters
   */
  async fetchExport(key: ExportType.Values, filters: ExportFilterInput): Promise<ExportResult> {
    // Config for the export request
    const config = {
      responseType: 'blob',
      timeout: 30000
    } as AxiosRequestConfig<ExportFilterInput>

    const response = await apiService.request<Blob, ExportFilterInput>(
      `exports/${ExportType.slug(key)}`,
      'POST',
      filters,
      config
    )
    const { filename } = response.parseDisposition()
    return ExportResult.create({
      filename: filename ?? 'export.xlsx',
      blob: response.data
    })
  }
}